import { useEffect, useState } from "react";
import { createContext } from "react";

export const LoaderContext = createContext({
  loader: false,
  setLoader: () => {}
});

export const LoaderProviderWrapper = ({ children }) => {
  const [loader, setLoader] = useState(false);

  return (
    <LoaderContext.Provider value={{ loader, setLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};
